import { useState } from "react";
import { Ban } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function VoidContract({ cid, disabled, onDone }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/contracts/${cid}/void`, { reason });
      toast.success("Contratto ritirato dalla firma: DocuSign ha avvisato i firmatari");
      setOpen(false); setReason(""); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" disabled={disabled} onClick={() => setOpen(true)} className="text-red-700 border-red-200 hover:bg-red-50" data-testid="contract-void"><Ban className="h-4 w-4 mr-1" />Ritira dalla firma</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent aria-describedby={undefined} className="bg-white max-w-md" data-testid="void-dialog">
          <DialogHeader><DialogTitle className="font-heading">Ritira il contratto dalla firma</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">La busta DocuSign viene annullata e i firmatari ricevono un'email con il motivo indicato. Il contratto torna modificabile.</p>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} maxLength={200} placeholder="Motivo del ritiro (obbligatorio, visibile al cliente)" data-testid="void-reason" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="void-cancel">Annulla</Button>
            <Button disabled={busy || reason.trim().length < 5} onClick={submit} className="bg-red-700 hover:bg-red-800 text-white" data-testid="void-submit">Ritira dalla firma</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
